import { API_BASE_URL, fetchWithTimeout, handleResponse } from "./shared";

// ============================================================================
// Organizations API (Custom Hierarchy Endpoints)
// ============================================================================

export interface OrgRecord {
  id: string;
  name: string;
  slug: string | null;
  logo: string | null;
  tenantId: string;
  parentId: string | null;
  createdAt: string;
}

export interface MemberRecord {
  id: string;
  userId: string;
  organizationId: string;
  role: string;
  createdAt: string;
  userName?: string;
  userEmail?: string;
}

export const organizationsApi = {
  async get(orgId: string): Promise<OrgRecord> {
    const response = await fetchWithTimeout(`${API_BASE_URL}/api/organizations/${orgId}`);
    return handleResponse<OrgRecord>(response);
  },

  async getChildren(orgId: string): Promise<OrgRecord[]> {
    const response = await fetchWithTimeout(
      `${API_BASE_URL}/api/organizations/${orgId}/children`
    );
    return handleResponse<OrgRecord[]>(response);
  },

  async getTree(orgId: string): Promise<OrgRecord[]> {
    const response = await fetchWithTimeout(
      `${API_BASE_URL}/api/organizations/${orgId}/tree`
    );
    return handleResponse<OrgRecord[]>(response);
  },

  async createChild(
    orgId: string,
    data: { name: string; slug?: string; logo?: string }
  ): Promise<OrgRecord> {
    const response = await fetchWithTimeout(
      `${API_BASE_URL}/api/organizations/${orgId}/create-child`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return handleResponse<OrgRecord>(response);
  },

  async getMembersCascaded(orgId: string): Promise<MemberRecord[]> {
    const response = await fetchWithTimeout(
      `${API_BASE_URL}/api/organizations/${orgId}/members-cascaded`
    );
    return handleResponse<MemberRecord[]>(response);
  },

  async createPersonal(name: string): Promise<OrgRecord> {
    const response = await fetchWithTimeout(
      `${API_BASE_URL}/api/organizations/create-personal`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name }),
      }
    );
    return handleResponse<OrgRecord>(response);
  },
};
